<script setup lang="ts">
/***
 * template to show ticket status badge
 */
import { computed } from 'vue';

import TicketStatusBadge from '@/components/layouts/common-components/TicketStatusBadge.vue';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();

const deadline = computed(() => {
  const stepDeadline = props.row.stepDeadlinedAt?.meta?.('rawvalue');
  const processDeadline = props.row.processDeadlinedAt?.meta?.('rawvalue');
  return stepDeadline || processDeadline;
});
</script>

<template>
  <TicketStatusBadge
    v-if="row.status.meta"
    :status="row.status.meta('rawvalue').toLowerCase().replace('ticketstatus_', '')"
    :deadline="deadline"
  />
</template>
